import styled from 'styled-components';
import { Col, Row } from 'components/layout/layout';

export const Root = styled.div`
    width: 100%;
    max-width: 300px;
`;

export const ColStyled = styled(Col)`
    justify-content: space-between;
    width: 100%;
    grid-auto-columns: max-content max-content;
`;

export const RowStyled = styled(Row)`
    width: 100%;
    grid-auto-columns: 100%;
`;
